/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_Toast_SuccessInputs */

const vi_customer_refund_toast_success = /** @type {(inputs: Customer_Refund_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lập phiếu hoàn tiền cho khách`)
};

/**

* @param {Customer_Refund_Toast_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_toast_success = /** @type {((inputs?: Customer_Refund_Toast_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_Toast_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_toast_success(inputs)
});